const Header = ({ img, title, content, blur = false, position }) => (
  <div className="">
    <div className="relative h-[504px] lg:h-[700px]">
      <div className="absolute inset-0 h-full">
        <img
          className={`h-full w-full object-cover ${
            position ? `object-${position}` : ''
          } ${blur ? 'blur-sm' : ''}`}
          src={`${img}?t=${new Date().toJSON().split('T')[0]}`}
          alt=""
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-blue" />
      </div>
      {title && (
        <div className="grid grid-cols-1 relative px-5 lg:px-14 pb-8 lg:pb-10 h-full lg:flex lg:flex-col lg:justify-end place-content-between leading-tight">
          <div className="flex lg:hidden mt-8 justify-end">{content}</div>
          <div className="grid grid-cols-1">
            <div className="flex justify-between">
              <h1 className="font-alliance-tight text-white text-[58px] lg:text-[110px] self-end">
                {title}
              </h1>
              {content && (
                <div className="hidden lg:flex align-middle mb-7">
                  {content}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
)

export default Header
